import React, { useEffect, useState } from "react";
import { View, Text, Button, useColorScheme } from "react-native";
import firebase from "firebase";
require("firebase/auth");
import {
  NavigationContainer,
  DefaultTheme,
  DarkTheme,
} from "@react-navigation/native";
import { useSelector, useDispatch } from "react-redux";
import * as userNftActions from "../store/actions/userNft";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { HeaderButtons, Item } from "react-navigation-header-buttons";
import CastButton from "../components/CastButton";
import MaterialButton from "../components/MaterialButton";
import HomeScreen from "../screens/HomeScreen";
import NoDeviceScreen from "../screens/device/NoDeviceScreen";
import DeviceScreen from "../screens/device/DeviceScreen";
import ArtScreen from "../screens/ArtScreen";
import Colors from "../constants/Colors";
import { Ionicons } from "@expo/vector-icons";
import PairDeviceScreen from "../screens/device/PairDeviceScreen";
import PairDeviceCameraScreen from "../screens/device/PairDeviceCameraScreen";
import DeviceDetailScreen from "../screens/device/DeviceDetailScreen";
import ProfileUserScreen from "../screens/profile/user/ProfileUserScreen";
import AddArtworkScreen from "../screens/profile/user/AddArtworkScreen";
import AddArtworkETHScreen from "../screens/profile/user/AddArtworkETHScreen";
import ForgotPasswordScreen from "../screens/profile/auth/ForgotPasswordScreen";
import EmailSentScreen from "../screens/profile/auth/EmailSentScreen";
import ProfileMainScreen from "../screens/profile/auth/ProfileMainScreen";
import ProfileAuthScreen from "../screens/profile/auth/ProfileAuthScreen";
import ProfileSettingScreen from "../screens/profile/user/ProfileSettingScreen";
import ProfileFAQScreen from "../screens/profile/user/ProfileFAQScreen";
import ProfileTermScreen from "../screens/profile/user/ProfileTermScreen";
import ProfilePrivacyScreen from "../screens/profile/user/ProfilePrivacyScreen";
import ProfileUpdatePWScreen from "../screens/profile/user/ProfileUpdatePWScreen";
import CreateArtScreen from "../screens/profile/user/CreateArtScreen";
import DeviceSettingScreen from "../screens/device/DeviceSettingScreen";

const MainNavigator = () => {
  const [isSignedIn, setIsSignedIn] = useState(false);
  const dispatch = useDispatch();

  const Tab = createBottomTabNavigator();
  const scheme = useColorScheme();

  const MyTheme = {
    dark: false,
    colors: {
      primary: Colors.accent,
      background: "black",
      card: "black",
      text: Colors.primary,
      border: "black",
      notification: "black",
    },
  };
  const HomeStack = createNativeStackNavigator();

  const HomeStackScreen = () => {
    return (
      <HomeStack.Navigator
        screenOptions={() => ({
          headerTitleAlign: "center",
        })}
      >
        <HomeStack.Screen
          name="HomeHome"
          component={HomeScreen}
          options={{
            title: "Home",
          }}
        />
        <HomeStack.Screen
          name="HomeArtScreen"
          component={ArtScreen}
          options={{
            title: "Artwork",
            animationEnabled: false,
          }}
        />
      </HomeStack.Navigator>
    );
  };

  const DeviceStack = createNativeStackNavigator();
  const DeviceStackScreen = () => {
    return (
      <DeviceStack.Navigator
        initialRouteName="DeviceScreen"
        screenOptions={() => ({
          headerTitleAlign: "center",
        })}
      >
        <DeviceStack.Screen
          name="DeviceScreen"
          component={DeviceScreen}
          options={({ navigation }) => ({
            title: "My Device",
          })}
        />
        <DeviceStack.Screen
          name="NoDeviceScreen"
          component={NoDeviceScreen}
          options={{
            title: "Device",
          }}
        />
        <DeviceStack.Screen
          name="PairDeviceScreen"
          component={PairDeviceCameraScreen}
          options={{
            title: "Device",
          }}
        />
        <DeviceStack.Screen
          name="DeviceDetailScreen"
          component={DeviceDetailScreen}
          options={{
            title: "Device",
          }}
        />
        <DeviceStack.Screen
          name="DeviceSettingScreen"
          component={DeviceSettingScreen}
          options={{
            title: "Device",
          }}
        />
        <DeviceStack.Screen
          name="DeviceArtScreen"
          component={ArtScreen}
          options={{
            title: "My Artwork",
            animationEnabled: false,
          }}
        />
      </DeviceStack.Navigator>
    );
  };

  const ProfileStack = createNativeStackNavigator();

  useEffect(() => {
    const subscriber = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        setIsSignedIn(true);
      } else {
        dispatch(userNftActions.logoutCleanup());
        setIsSignedIn(false);
      }
    });
  }, []);

  const ProfileAuthStackScreen = () => {
    return (
      <ProfileStack.Navigator
        initialRouteName="ProfileMainScreen"
        screenOptions={() => ({
          headerTitleAlign: "center",
        })}
      >
        <ProfileStack.Screen
          name="ProfileAuthScreen"
          component={ProfileAuthScreen}
          options={({ route }) => ({
            title: route.params.isSignup ? "Sign Up" : "Log in",
          })}
        />
        <ProfileStack.Screen
          name="ProfileMainScreen"
          component={ProfileMainScreen}
          options={{
            title: "",
          }}
        />
        <ProfileStack.Screen
          name="ForgotPasswordScreen"
          component={ForgotPasswordScreen}
          options={{
            title: "Forgot PassWord",
          }}
        />
        <ProfileStack.Screen
          name="EmailSentScreen"
          component={EmailSentScreen}
          options={{
            title: "Forgot PassWord",
          }}
        />
        <ProfileStack.Screen
          name="ProfileTermScreen"
          component={ProfileTermScreen}
          options={{
            title: "Term of Use",
          }}
        />

        <ProfileStack.Screen
          name="ProfilePrivacyScreen"
          component={ProfilePrivacyScreen}
          options={{
            title: "Privacy Policy",
          }}
        />
      </ProfileStack.Navigator>
    );
  };

  const ProfileStackScreen = () => {
    return (
      <ProfileStack.Navigator
        initialRouteName="ProfileUserScreen"
        screenOptions={() => ({
          headerTitleAlign: "center",
        })}
      >
        <ProfileStack.Screen
          name="ProfileUserScreen"
          component={ProfileUserScreen}
          options={({ navigation }) => ({
            title: "My Profile",
          })}
        />
        <ProfileStack.Screen
          name="AddArtworkScreen"
          component={AddArtworkScreen}
          options={{ title: "" }}
        />
        <ProfileStack.Screen
          name="AddArtworkETHScreen"
          component={AddArtworkETHScreen}
          options={{ title: "Add ETH Address" }}
        />
        <ProfileStack.Screen
          name="ProfileArtScreen"
          component={ArtScreen}
          options={{
            title: "My Artwork",
            animationEnabled: false,
          }}
        />
        <ProfileStack.Screen
          name="CreateArtScreen"
          component={CreateArtScreen}
          options={{
            title: "Upload",
          }}
        />

        <ProfileStack.Screen
          name="ProfileSettingScreen"
          component={ProfileSettingScreen}
          options={{
            title: "Settings",
          }}
        />
        <ProfileStack.Screen
          name="ProfileFAQScreen"
          component={ProfileFAQScreen}
          options={{
            title: "FAQ",
          }}
        />
        <ProfileStack.Screen
          name="ProfileTermScreen"
          component={ProfileTermScreen}
          options={{
            title: "Term of Use",
          }}
        />
        <ProfileStack.Screen
          name="ProfilePrivacyScreen"
          component={ProfilePrivacyScreen}
          options={{
            title: "Privacy Policy",
          }}
        />
        <ProfileStack.Screen
          name="ProfileUpdatePWScreen"
          component={ProfileUpdatePWScreen}
          options={{
            title: "Update Password",
          }}
        />
      </ProfileStack.Navigator>
    );
  };

  return (
    <NavigationContainer theme={MyTheme}>
      <Tab.Navigator
        screenOptions={({ route }) => ({
          headerShown: false,
          tabBarIcon: ({ focused, color, size }) => {
            let iconName;

            if (route.name === "Home") {
              iconName = focused ? "ios-home" : "ios-home-outline";
            } else if (route.name === "Profile") {
              iconName = focused ? "ios-person" : "ios-person-outline";
            } else if (route.name === "Device") {
              iconName = focused ? "ios-tv" : "ios-tv-outline";
            }
            color = "white";
            return <Ionicons name={iconName} size={size} color={color} />;
          },
          tabBarActiveTintColor: Colors.accent,
          tabBarInactiveTintColor: "gray",
        })}
      >
        <Tab.Screen name="Home" component={HomeStackScreen} />
        <Tab.Screen
          name="Profile"
          component={isSignedIn ? ProfileStackScreen : ProfileAuthStackScreen}
        />
        <Tab.Screen name="Device" component={DeviceStackScreen} />
      </Tab.Navigator>
    </NavigationContainer>
  );
};

export default MainNavigator;
